import React from 'react';
import IconLink from '../Icon/IconLink';
import { logout } from '../../services/auth';
import useMode from '../../hooks/useMode';
import { UserMode } from '../../hooks/useApolloClient';
import { IconType } from '../Icon/Icon';

type UserMenuItem = {
  icon: IconType;
  text: string;
  href: string;
};

export const userMenuLinks: Record<UserMode, UserMenuItem[]> = {
  'water-supplier': [
    {
      icon: 'settings',
      text: 'Manage Account',
      href: '/water-supplier/profile',
    },
    { icon: 'people', text: 'Users', href: '/water-supplier/users' },
  ],
  company: [
    { icon: 'settings', text: 'Manage Account', href: '/company/profile' },
    { icon: 'people', text: 'Users', href: '/company/users' },
  ],
  admin: [],
  individual: [],
};

const UserMenu = (): JSX.Element => {
  const mode = useMode();

  return (
    <>
      {userMenuLinks[mode].map((link, index) => (
        <IconLink key={index} pr={8} icon={link.icon} isDark href={link.href}>
          {link.text}
        </IconLink>
      ))}
      <IconLink pr={8} icon="logout" isDark onClick={logout}>
        Log Out
      </IconLink>
    </>
  );
};

export default UserMenu;
